import probingOperations from './probing/operations';

export default function ProbingProgram(props) {
  const {
    program = [],
    activeOperation,
    highlightedOperation,
    onSetHighlightedOperation,
    onSetActiveOperation,
    machine,
    onSave,
    onRevert
  } = props;

  return <div>
  { program.cmds.map((op, index) => {
    const { cmd } = op;
    const Operation = probingOperations[cmd];

    const handleHighlight = () => {
      onSetHighlightedOperation(index);
    };

    const handleClearHighlight = () => {
      onSetHighlightedOperation(-1);
    };

    const handleSetActive = () => {
      onSetActiveOperation(index);
    };

    const handleSave = (args) => {
      onSave(index, args);
    };

    const handleRevert = () => {
      onRevert(index);
    };

    return <Operation key={index} 
                      machine={machine}
                      onSetActiveOperation={handleSetActive}
                      onSetHighlightedOperation={handleHighlight} 
                      onClearHighlightedOperation={handleClearHighlight} 
                      onSave={handleSave}
                      onRevert={handleRevert}
                      active={activeOperation === index} 
                      highlighted={highlightedOperation === index} op={op}
                      activeOperation={activeOperation}/>
  }) }
  </div>;
}
